export default (() => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0
  };
  const elementToCallback = new WeakMap();
  const handleIntersection = function (entries, observer) {
    for (const entry of entries) {
      if (entry.intersectionRatio <= 0) {
        continue;
      }

      // Stop observing.
      observer.unobserve(entry.target);
      if (!elementToCallback.has(entry.target)) {
        continue;
      }

      // Invoke callback.
      elementToCallback.get(entry.target)();
    }
  };
  const observer = new IntersectionObserver(handleIntersection, options);

  // Attributes.
  const attributes = document.querySelectorAll('[data-onintersect][data-intersect-id]');
  for (const element of attributes) {
    const intersectElement = document.getElementById(element.getAttribute('data-intersect-id'));
    if (!intersectElement) {
      continue;
    }
    const onIntersect = function () {
      let values = element.getAttribute('data-onintersect');
      values = values.split(',');
      for (let value of values) {
        value = value.split('=');
        if (value.length > 1) {
          element.setAttribute(value.shift(), value.join('='));
        } else {
          element.setAttribute(value[0], true);
        }
      }
    };
    elementToCallback.set(intersectElement, onIntersect);
    observer.observe(intersectElement);
  }

  // Styles.
  const styles = document.querySelectorAll('link[href][type="text/intersect"][data-intersect-id]');
  for (const element of styles) {
    const intersectElement = document.getElementById(element.getAttribute('data-intersect-id'));
    if (!intersectElement) {
      continue;
    }
    const onIntersect = function () {
      // Create new element.
      const newElement = document.createElement('link');
      // Transfer attributes.
      for (const oldAttribute of element.attributes) {
        if (oldAttribute.name !== 'type') {
          newElement.setAttribute(oldAttribute.name, oldAttribute.value);
        }
      }
      // Set updated type.
      newElement.setAttribute('type', 'text/css');
      // Add new element to same parent as old.
      element.parentElement.appendChild(newElement);
      // Remove old attribute.
      element.remove();
    };
    elementToCallback.set(intersectElement, onIntersect);
    observer.observe(intersectElement);
  }

  // Scripts.
  const scripts = document.querySelectorAll('script[src][type="text/intersect"][data-intersect-id]');
  for (const element of scripts) {
    const intersectElement = document.getElementById(element.getAttribute('data-intersect-id'));
    if (!intersectElement) {
      continue;
    }
    const onIntersect = function () {
      // Create new element.
      const newElement = document.createElement('script');
      // Transfer attributes.
      for (const oldAttribute of element.attributes) {
        if (oldAttribute.name !== 'type') {
          newElement.setAttribute(oldAttribute.name, oldAttribute.value);
        }
      }
      // Set updated type.
      newElement.setAttribute('type', 'text/javascript');
      // Add new element to same parent as old.
      element.parentElement.appendChild(newElement);
      // Remove old attribute.
      element.remove();
    };
    elementToCallback.set(intersectElement, onIntersect);
    observer.observe(intersectElement);
  }
});